export default {
    home: 'Home',
    adminTitle: 'BRAND CENTER',
    zh_CN: 'zh_CN',
    en_US: 'en_US',
    CN: 'zh_CN',
    EN: 'en_US',
    save: 'Save',
    cancel: 'Cancel',
    reset: "Reset",
    confirm: 'Confirm',
    search: 'Search',
    add: "Add",
    detail: 'Detail',
    upload: 'Upload',
    delete: 'Delete',
    edit: 'Edit',
    multiLanguage:'Multi-Language',
    inputPlaceholder: 'Please input',
    selectPlaceholder: 'Please select',
    selectloadingPlaceholder: 'Loading',
    yes: 'Yes',
    no: 'No',
    update: 'Update',
    OperationFailed: 'Operation failed',
    AcquisitionFailed: 'Acquisition failed',
    set: 'Setting',
    logout: 'Logout',
    changepwd: 'Change password',
    resetpwd: 'Reset password',
    success: 'Operation successful',
    failed: 'Operation failed',
    required: 'Mandatory fields cannot be empty',
    nodata: 'No Data',
    legend: 'Legend',
    Registeredusers: 'Registered users',
    RecordNo:"",
    copyright:"©2021-present hyecosmart.com All rights reserved",
    All:'All',
    upError: {
        formatError: 'File format error',
        pleaseSele: 'Please select',
        file: 'file ',
        type: 'type',
        name:'Name format error'
    },
    img: {
        success: 'Upload succeeded',
        failed: 'Upload failed',
    },
    ruleCustom: {
        pwd: 'Please enter a combination of uppercase and lowercase letters and numbers, with a length between 6 and 20.',
        email: 'Please enter a valid email address (e.g. name@example.com)',
        phone: 'Please enter a valid phone number (digits only)',
        vercode: 'Verification code must be filled in',
        positive_integer: 'Please enter a positive integer',
        non_negative_integer:'Please enter a non negative integer',
        16: "Please enter hexadecimal format, starting with '0x'",
        '0x3f': "0x00~0x3f",
        productType: 'No Chinese input',
        basicName: "Please enter a string consisting of letters, numbers, underscores, dashes, or spaces",
        format:'Incorrect format',
        pageId:'Please enter a string in numeric format',
        l100:'The number of words cannot be greater than 100',
        l50:'The number of words cannot be greater than 50',
        fixedTelephone:'Country code, starting with "+", 1 to 3 digits; Area code, 2-3 digits, cannot start with "0"; Number, 7 to 8 digits; E.g. + 86 11 1234567',
        wordCode:'It supports upper and lower case letters, numbers and underscores, with no more than 50 characters.',
        UIcode:'It supports upper and lower case letters, numbers and underscores, with no more than 36 characters.',
        blankCode:'Please enter a non-empty string or white space character',
        httpLink:'Please enter a valid URL starting with http:// or https://'
    },
    success:{
        sync:'Successfully synchronized data'
     },
     error:{
        sync:'Failed to synchronize data'
     },
    selectList: {
        MessageStatus:{
            New: 'New',
            Read: 'Read',
            Reply: 'Reply'
        },
        functionCategoryList: {
            'Water_equipment': 'Water equipment',
            'Raingauge': 'Raingauge',
            'Flowgauge': 'Flowgauge',
            'Soil_moisture_detector': 'Soil moisture detector'
        },
        connectionTypeList: {
            'BLE': 'BLE',
            'BLEMesh': 'BLEMesh',
            'BLE5': 'BLE5.0',
            'WIFI': 'WIFI',
            'LORADTU': 'LORADTU',
            'LORAWan': 'LORAWan',
        },
        standardTypeList: {
            'Yes': 'Yes',
            'No': 'No'
        },
        StatusList: {
            'Test': 'Test',
            'Big_sale': 'Big sale',
            'Stop_sale': 'Stop sale'
        },
        deviceStatus: {
            Free: 'Free',
            Activate: 'Activate',
            Return: 'Return',
        },
        onlineType: {
            Online: 'Online',
            Outline: 'Offline',
            Disabled: 'Disabled'
        },
        releaseTypeList: {
            beta: 'Beta',
            release: 'Release',
        },
        appStatusList: {
            'Online': 'Online',
            'Expired': 'Expired',
        },
        comModeListBasic: {
            'BLE': 'BLE',
            'WIFI': 'WIFI',
            'LORADTU': 'LORADTU',
            'LORAWan': 'LORAWan',
            'BLEMesh': 'BLEMesh',
            'BLE5': 'BLE5.0',
            '4GCat1': '4G cat1',
            'RS485':'RS485',
            '4G':'4G',
            'other':'OTHER/UNKNOWN',
        },
        connectListBasic: {
            'Not_networked': 'Not networked',
            'Gateway': 'Gateway',
            'Gateway_device': 'Gateway device',
            'direct-connected_facility': 'Directly connected device',
            'base_station':'Base station',
            'base_station_facility':'Base station device',
        },
        smDeviceTypeBasic: {
            'Main_equipment': 'Main equipment',
            'Rain_gauge': 'Auxiliary rain gauge',
            'Valve_flowmeter': 'Auxiliary valve flowmeter',
            'Soil_hygrometer': 'Auxiliary soil hygrometer',
        },
        loraProductKeyBasic: {
            'A6k_t3Rng': 'LoRaWan classA',
            'u_ElpqR7R': 'LoRaWan classB',
            'HJTutqgnR': 'LoRaWan classC',
            'aYFrpqg7g': 'LoRaWan base station',
            'None': 'None'
        },
        RWlist: {
            'R': 'Read-only',
            'RW': 'Read/Write'
        },
        MustedList: {
            'true': 'Y',
            'false': 'N'
        },
        designImplTypeList: {
            'type1': 'BLE synchronization',
            'type2': 'Binary KLV',
            'type3':'HyECO plateform Json',
            'type4':'Aqube platform Json',
            'type5':' WIFI synchronization',
        },
        subdeviceTypeList:{
            'LORAWAN':'LORAWAN',
            'LORAWAN_A': 'LoRaWan classA',
            'LORAWAN_B': 'LoRaWan classB',
            'LORAWAN_C': 'LoRaWan classC',
            'LORADTU':'LORADTU',
            'MODBUS':'MODBUS',
            'HYBUS':'HYBUS',
          },
        communicateProtocolList: {
            'type1': 'BIT KLV V1.0',
            'type2': 'MULTI SITES IRRIGATION V1.0',
            'type3': 'Character kV protocol v1',
            'type4': 'OTHER/NONE',
            'type5':'Hypeco_JSON_Lite_V1',
        },
        joinSenseList: {
            'true': 'Yes',
            'false': 'No',
            'type1':'Only as a condition',
            'type2':'Only to be executed',
            'type3':'None is allowed',
            'type4':'Both are allowed ',
        },
        timeUnit: {
            'year': '年(year)',
            'month': '月(month)',
            'day': '日(day)',
            'hour': '时(h)',
            'minute': '分(min)',
            'second': '秒(s)',
            'msceond': '毫秒(ms)'
        },
        transactionType:{
            "Recharge":"Recharge",
            "SMS":"SMS charges",
            "other":"Other expenses, one-time deduction",
            "Activate":"Activation equipment deduction"
        },
        whetherRun:{
            "Running":"Running",
            "Stoped":"Stoped"
        }
    },
    loginPage: {
        userName: 'User name',
        password: 'Password',
        VerificationCode: 'Verification Code',
        RememberPassword: 'Remember password',
        ForgetPassword: 'Forget password',
        Signin: 'Sign in',
        forget: {
            title: 'Identity Check',
            stitle: 'Please enter the email account for reset password',
            email: "User email",
            code: "Verification Code",
        },
        reset: {
            title: 'Set new password'
        }
    },
    topCon: {
        CurrentPassword: 'Current password',
        NewPassword: 'New password',
        NewPassword1: 'Confirm new password',
        confirmOut: 'Are you sure you want to log out?',
        colseLeft: 'Close the left side',
        colseRight: 'Close the right side',
        colseOther: 'Close other',
        dealerInfoErr:'Please complete the information on the settings page'
    },
    homePage: {
        Products: 'Products',
        Market: 'Market',
        User: 'User',
        Total: 'Total',
        Online: 'Online',
        Device: 'Device',
        Active: 'Active',
        Online1: 'Online',
        App: 'App',
        LastAndroidVer: 'Last Android Ver',
        LastAppleVer: 'Last Apple Ver',
        Messages: 'Messages',
        New: 'New',
        Push: 'Push',
        PushOfTotal: 'Push Of Total',
        Log: 'Log',
        LogToday: 'Log Today',
        UserAssociation: 'Admin',
        Associated:'Associated users',
        UnAssociated:'Unassociated users'
    },
    loginStatistics: {
        LoginId: 'Login id',
        User: 'User',
        OperationalSystem: 'Operation system',
        echartsTitle: 'Login 30days：',
        titleName: {
            Login_id: 'Login id',
            Login_time: 'Login time',
            Email: 'Email',
            Phone: 'Phone',
            os: 'Operation system',
            App: 'App version',
            Location: 'Location',
        }
    },
    productManage: {
        create: 'New product',
        ManageGroup: 'Manage product group',
        createDate: 'Marketing time',
        activateNumber: 'Activation amount',
        productType: 'Product type',
        Release_status: 'Release status',
        Evaluate:'Evaluative information',
        addModel: {
            TypeID: 'ID',
            title: 'New product',
            productType: 'Type',
            name: 'Product name',
            smDeviceType: 'Function category',
            channelNumber: 'Branch',
            sellUnitPrice: 'Purchase price',
            activateUnitPrice: 'Activate price',
            remark: 'Remark',
            groupId: 'Group',
            comMode: 'Connection type',
            macQty: 'MAC quantity',
            pageId: 'Pages',
            normalMode: 'Standard type',
            baseType: 'Basic type',
            marketDate: 'On market',
            status: 'Status',
            photo: 'Photo',
            photoS: 'Small picture',
            photoM: 'Middle picture',
            photoB: 'Big picture',
            photoSTip: 'Requirements: 200×200px, centered, transparent background, size ≤500KB',
            photoMTip: 'Requirements: 400×400px, centered, transparent background, size ≤500KB',
            photoBTip: 'Requirements: 800×800px, centered, transparent background, size ≤500KB',
            Select_template: 'Select template',
            Templet: 'Templet',
            Function_Editor: 'Function',
            Publish: 'Publish',
            aqubeCertify: 'Aqube certify',
            CreateTime: 'Create time',
            share:'Share',
            newFirmware:'New Firmware'
        },
        validateAdd: {
            basicTypeId: 'Please select a template first',
            photo: 'Please upload product pictures'
        },
        popTitle: 'Are you sure you want to publish',
        editModel: {
            title: 'Edit product',
        },
        manageModel: {
            title: 'Manage group',
            new: 'New product group',
            Product_group: 'Product group',
            Operation: 'Operation',
            stitle: 'New group',
            sname: 'New type'
        },
        functionModel: {
            title: 'Product function definition',
            titleName: {
                FunctionGroup: 'Feature name',
                Indentifier: 'Indentifier',
                IndentifierName: 'IndentifierName',
                Discription: 'Discription',
                Musted: 'Required',
                Select: 'Select',
                defaultValue: 'Default value',
                major:'Main function'
            },
            inputPlaceholder: {
                hexstring: 'Define byte length ,nBytes',
                string: 'Define byte length',
            }
        },
        evaluateModel:{
            title:'Evaluation list',
            information:'evaluation information',
            shield:'shielding',
            disclosure:'disclosure'
        }
    },
    productPage: {
        titleName: {
            Page_id: 'Page id',
            Description: 'Description',
            Photos: 'Photos',
            Remark: 'Remark',
            Date_created: 'Date created',
            View: 'View',
            Operation: 'Operation',
            uiCode_id:'UI code',
            type:'Type',
        },
        addBox: {
            title: 'New Page',
            title1: 'Edit Page'
        },
        mulLang:{
            addTitle:'New entry',
            editTitle:'Edit entry',
            whetherSync:'Dealer dictionary synchronization changes',
            download:'Download',
            downloadAll:'Download all',
            creating:'The entry is being created, please do not close the page',
            total:'Total',
            valid:'valid',
            success:'successful',
            fail:'failed',
            tipContent:'Are you sure to create these entries?',
            importTitle:'Import',
            exportTitle:'Export',
            importTip:'Import Xlsx or Xls type excel file',
            readS:"File read successful",
            readF:"File read error",
            finish:'Creation complete'
        },
        tip:'Changing the multilingual entry on the next aspect page will change the language tags on the app.'
    },
    BasicProduct: {
        addParams: "New parameter",
        titleName: {
            basicName: 'Basic name',
            baseNick: 'Product name',
            Id:'Template id',
            pageId: 'Page id',
            comMode: 'Communication mode',
            comType:'Communication type',
            connectMode: 'Connection type',
            channelNumber: 'Branch',
            macQty: 'MAC quantity',
            smDeviceType: 'Function category',
            loraProductKey: 'LoRaKey',
            loraProductKeyOne:'Product docking',
            frequency: 'frequency',
            imageId: 'Image',
            designImplType: 'Implementation type',
            basicClassId: 'Basic Class',
            joinSense: 'scene interaction',
            remark: 'Remark',
            whetherShare: "Whether share",
            communicateProtocol: "Protocol",
            majorKey:'Main function key',
            interactionChannel:'Interaction channel',
            modifyModelSync:'Do you want to synchronize the modification of dealer models?',
            modifyDeviceSync:'Do you want to synchronize device modifications?',
            deactivateModelSync:'Do you want to deactivate this model?',
            disabled:'Deactivation',
            subdeviceType:'Sub device type'
        },
        comTypeBox:{
            up:'Uplink communication method',
            down:'Downlink communication method',
            tip:'Explanation: 2G/3G/4G/5G all belong to the CELL network',
          },
        addBox: {
            title: 'Create base model',
            title1: 'Edit base model',
            title2: 'General functions / parameters',
        },
        basicClassBox:{
            edit:'Edit Classification',
            name:'Calss name',
            title:'Create',
            title1:'Edit',
            errorInfo:'There are subcategories under the category, please delete the subcategories first'
        },
        funcBox: {
            title: 'Function',
            add: 'Add',
            import:'Import',
            sync:'Synchronize HyECO platform data',
            imported:'Import data for the same model',
            importedFunc:'Import existing model data',
            importedExcel:'Import Excel',
            exportedExcel:'Export Excel',
            tipContent:'Are you sure you want to create these features',
            sideList: {
                topSide1: 'Device function',
                topSide2: 'Cloud function',
                topSide3:'Other Operations',
                side1: 'Event',
                side2: 'Function',
                side3: 'Parameter',
                side4: 'General Function',
                side5: 'General Parameter',
                side8: 'Cloud Parameter',
                side6: 'Record',
                side7: 'Message',
                side8:'Operation',
            },
            titleName: {
                Order: 'No.',
                Identifier: 'Identifier',
                IndentyName: 'IndentyName',
                Discription: 'Discription',
                Value: 'Value',
                Default: 'Default',
                Bytes: 'Bytes',
                stringLang: 'StrLen',
                RW: 'R/W',
                Musted: 'Required',
                Remark: 'Remark',
                DeviceAction: 'Device action',
                DeviceInterface: 'Device interface',
                UIcontroller: 'UI controller',
                conditionalControl:'Conditional controller',
                DataType: 'Data type',
                ElementType:'Element type',
                TypeDiscription: 'Params discription',
                Unit: 'Unit',
                VIP: 'VIP',
                VIPcost: 'VIPcost',
                SenseCondition: 'Sense condition',
                SenseAction: 'Sense action',
                SenseOperation: 'Sense operation',
                UpdateAsOffline: 'Update asOffline',
                Max: 'Max value',
                Min: 'Min value',
                Decimals: 'Decimals',
                Step: 'Step',
                Multiple: 'Multiple',
                Negative: 'Negative',
                'Unit-CN': 'Unit- Chinese',
                'Unit-EN': 'Unit- English',
                LanguageKey: 'Language key',
                '0x00 wordId':'0x00 - Language key',
                '0x01 wordId':'0x01 - Language key',
                'True wordId':'True - Language key',
                'False wordId':'False - Language key',
                '0x00-CN': '0x00 - Chinese description',
                '0x01-CN': '0x01 - Chinese description',
                '0x00-EN': '0x00 - English description',
                '0x01-EN': '0x01 - English description',
                'True-CN': 'True - Chinese description',
                'False-CN': 'False - Chinese description',
                'True-EN': 'True - English description',
                'False-EN': 'False - English description',
                timeFormate: 'Time formate',
                time: 'Time unit',
                Name: 'Name',
                'Name-CN': 'Name - Chinese',
                'Name-EN': 'Name - English',
                Offset: 'Offset',
                Len: 'Length',
                'ValueRange': "Value range",
                wordEntry:'Entry',
                placeholderWord:'Please select the language key',
                Enumeration:'Enum',
                resetSync:'Do you want to reset the device defaults?',
            },
            titleNameLog: {
                Id: 'Id',
                Datetime: 'Datetime',
                UpdateContents: 'Update Contents',
                Remark: 'Remark'
            },
            TypeDiscriptionPlaceholder: 'Please select the DataType first',
            VerificationFailed:'Verification failed',
            selectList: {
                Numerical: 'Numerical',
                Enumeration: 'Enumeration',
                Boolean: 'Boolean',
                String: 'String',
                Datetime: 'Datetime',
                HexNumerical: 'Hex Numerical',
                HexEnumeration: 'Hex Enumeration',
                HexBoolean: 'Hex Boolean',
                HexString: 'Hex String',
                HexDatetime: 'Hex Datetime',
                HexBitvalue: 'Hex Bitvalue',
            }
        },
        adminBox:{
            title:'Administrator verification',
            password:'Administrator Password',
            save:'Verify and Operate'
        }
    },
    deviceManage: {
        topTotal1: 'Total',
        topTotal2: 'Activate in 30days',
        topTotal3: ' Device online',
        serialNumber: 'Serial number',
        macAddress: 'MAC',
        baseType: 'Basic type',
        status: 'Device status',
        whetherOnline: 'Online/ Offline',
        Move: 'Move',
        AssignedVendor:'Assigned installer',
        Installer:'Installer',
        MoveLog: 'Move log',
        MoveInner: 'Internal movement',
        joinHome: 'Join Home',
        Reported: 'Reported message',
        command:'Command',
        ManageGroup: 'Manage group',
        filter: 'Filter',
        export: 'Export',
        print: 'Print',
        Unbundling: 'Unbundling',
        UnbundlingCont: "Are you sure you want to unbind?",
        titleName: {
            Serial_number: 'Serial number',
            Home_id:'Family id',
            MAC: 'MAC',
            Type: 'Type',
            Device_group: 'Device group',
            Activate: 'Activate',
            whetherOnline: 'Online/Offline',
            Activate_time: 'Activate time',
            User_account: 'User account',
            Location: 'Location',
            Sync_time: 'Sync time',
            Last_update: 'Last update',
            Operation: 'Operation',
        },
        addModel: {
            title: 'Move device group',
            groupName: 'Device group'
        },
        commandModel:{
            title: 'command information',
            firmwareUpgrade:'Firmware upgrade',
            gatewayRestart:'Gateway restart',
            add:'Send',
            code:'Command code',
            value:'Command value'
        },
        reportModel:{
            title: 'Device reporting information query',
            tip:'Please first select the message category you want to query, and then click the search button to search',
            type:'Type',
            value:'Value',
            commandKeyType:'Type',
            commandKey:'Function'
        },
        manageModel: {
            title: 'Manage group',
            new: 'New group',
            titleName: {
                ProductName: 'OEM Model',
                Group_name: 'Group name',
                Remark: 'Remark',
                Member: 'Member',
                Operation: 'Operation',
            },
            stitle: 'New group',
            stitle1: 'Edit group',
            sname: 'Group name',
            remark: 'Remark'
        },
        dealerModel: {
            title: 'Move dealer',
            Dealer: 'Dealer',
            Order: 'Order',
            Basic_type: 'Basic type',
            noOrder: 'No orders available',
            titleName:{
                moveTime:'Move time',
                previousDealerID:'Prev dealer',
                previousOrderID:'Prev order',
                previousOrderName:'Prev order name',
                currentDealerID:'Current dealer',
                currentOrderID:'Current order',
                currentOrderName:'Current order name',
                remark:'Remark',
              }
        }
    },
    userManage: {
        topTotal1: 'Total：',
        topTotal2: 'New in 30days：',
        topTotal3: 'Online：',
        dealerUserGroup: 'Group',
        emailAddress: 'Email',
        phoneNumber: 'Mobile phone',
        userAccount: 'User account',
        os: 'Operation system',
        livenessLessThen: 'Liveness<',
        livenessGreaterThen: 'Liveness>',
        Move: 'Move',
        ManageGroup: 'Manage group',
        Block: 'Block',
        Unlock: 'Unlock',
        titleName: {
            Account: 'Account',
            userId: 'User Id',
            userName: 'User',
            Email: 'Email',
            Group_name: 'Group name',
            Status: 'Status',
            Operational: 'Operational',
            App: 'App',
            Liveness: 'Liveness',
            Registration_time: 'Registration time',
            Phone: 'Phone',
            Contact_address: 'Contact address',
        },
        addModel: {
            title: 'Move user group',
            groupName: 'User group'
        },
        manageModel: {
            title: 'Manage group',
            new: 'New group',
            titleName: {
                Group_name: 'Group name',
                Remark: 'Remark',
                Member_number: 'Member number',
                Operation: 'Operation',
            },
            stitle: 'New group',
            sname: 'Group name',
            remark: 'Remark'
        },
        associate:{
            addTitle:'Bind user',
            criteria:'Search criteria',
            userName:'Managers'
        },
        addUserModel:{
            title:'Create User',
            title1:'Edit User',
            titleName:{
                signUpOptions:'Register via',
                countryCode:'Country code',
            },
            selectPlaceholder: {
              country:'Please select a country'
            },
          }
    },
    sideList: {
        home: 'Home',
        Products: 'Products',
        Pages: 'Pages',
        BasicProduct: 'Basic',
        Order: 'Order',
        User: 'User',
        Login: 'Login',
        Device: 'Device',
        DeviceCenter: 'Device Center',
        Location: 'Location',
        firmwareCenter: 'Firmware',
        firmwareVersion: 'Version',
        firmwarePlan: 'Plan',
        firmwareDownload: 'Download',
        AppCenter: 'App Center',
        appVersion: 'Version',
        appPlan: ' Plan',
        appDownload: 'Download',
        appDevice:'Device',
        AccountCenter: ' Account ',
        SMScost: 'SMS cost',
        accountRecharge: 'Recharge',
        accountHistory: 'History',
        feedBack: 'Feedback',
        pushMessage: 'Push',
        setting: 'Setting',
        templateProduct: 'Product Template',
        UiController:'Controls',
        sceneModel:'Scene',
        Installer: 'Installation Vendor',
        onboardingBanner:'Onboarding'
    },
    formRules: {
        fmtPassword: 'The password format is numbers and letters, and the length is 6 to 10',
        twoPassword_notMatch: 'The two passwords did not match'
    },
    orderManage: {
        addButton: 'New Order',
        editButton:'Edit Order',
        detail: "Detail",
        delete: "Delete",
        Realize: 'Realize',
        Instance: 'Instantiate',
        titleName: {
            Order: 'Order',
            OrderId: 'Order id',
            OrderDate: 'Order date',
            ProductId: 'Product id',
            Type: 'Type',
            ProductName: 'Product name',
            Qty: 'Qty',
            Remark: 'Remark',
            Operation: 'Operation',
        },
        addModel: {
            title: 'New Order',
            orderId: "Order",
            orderDate: "Order date",
            orderProductType: "Type",
            qty: "Order qty",
            remark: "Remark",
            hardware: "Hardware version",
            firmware: "Firmware version",
            needPublish: 'Please release the product first',
            frequency:'Operating frequency'
        },
        detailModel: {
            title: 'Order',
            serialNumber: "Serial number",
            macAddress: "macAddress",
            deviceId: 'Device id',
            mqttPassword: 'Password',
        },
        deletModel: {
            changeTitle: 'Delete',
            changeCont: 'Are you sure you want to delete? Deleting this part will permanently erase it'
        }
    },
    firmwareDownload: {
        titleName: {
            id: 'Firmware id',
            downloadTime: 'Download time',
            serialNumber: 'Serial number',
            userAccount: 'User account',
            deviceType: 'Device type',
            beforeDownVersion: 'Old version',
            afterDownVersion: 'New version',
        }
    },
    firmwarePlan: {
        titleName: {
            id: 'Id',
            createTime: 'Plan date',
            fwareId: 'Firmware id',
            fwareVersion: 'Version',
            deviceGroupName: 'Device group',
            totalDevices: 'Device count',
            updateDevices: 'Update count',
            whetherRun: 'Plan status',
            Operation: 'Operation',
            number: 'Batch quantity',
            unit: 'Interval unit',
            interval: 'Interval time',
            minNumber:'Interval minutes'
        },
        tip:{
            five:'The maximum quantity is 500',
            six:'Please enter an integer between 1 and 600'
        },
        addButton: 'New plan',
        editButton: 'Edit plan',
        allGroup: 'All group',
        need: {
            fwareId: 'Please add firmware first'
        }
    },
    firmwareVersion: {
        start: 'start',
        stop: 'stop',
        changeTitle: 'Change status',
        changeCont: 'Are you sure you want to change the status?',
        titleName: {
            id: 'Firmware id',
            fwareVersion: 'Version',
            hardwareVersion: 'Hardware version',
            fileName: 'File name',
            suitDeviceType: 'Device type',
            updateInformation: 'Update message',
            releaseTime: 'Release date	',
            uploadTime: 'Upload date',
            remark: 'Remark',
            baseTypeId:'Basic type id',
            baseType:'Basic type',
            minVer:'Minimum Version',
            maxVer:'Maximum Version',
            otherRemark:'Remark',
        },
        addButton: 'New firmware',
        addBox: {
            fileName: 'Apk file',
            title1: 'Update message',
            title2: 'Settings',
            title3: 'Other',
        },
        require: {
            hardwareVersion: 'Please upload the package file that meets the rules',
            formatError: "Only files in the BIN, ZIP, PAG formats are supported."
        }
    },
    editMesageModule: {
        title_editMessage: 'Edit message',
        lang_zh: 'Chinese message',
        lang_zh_ft: 'Traditional Chinese',
        lang_en: 'English message',
        lang_fr: 'French message',
        lang_de: 'German message',
        lang_es: 'Spanish message',
        lang_ja: 'Japanese message',
    },
    appDownload: {
        titleName: {
            id: 'Id',
            downloadTime: 'Download time',
            os: 'Operation system	',
            userAccount: 'Account',
            beforeDownVersion: 'Old version',
            afterDownVersion: 'New version',
        }
    },
    appPlan: {
        addButton: 'New plan',
        editButton: 'Edit plan',
        titleName: {
            id: 'Id',
            canUseDate: 'Plan date',
            appId: 'App id',
            version: 'Version',
            releaseType: 'Release type',
            appStatus: 'App status',
            os: 'Operational',
            deviceGroupName: 'User group',
            totalUser: 'User count',
            completeUpdateUser: 'Update count',
            whetherRun: 'Plan status',
            Operation: 'Operation'
        },
        needappId: 'Please create an application number first',
    },
    appVersion: {
        addButton: 'New app',
        Expire: 'Expire',
        titleName: {
            id: 'Id',
            version: 'Version',
            releaseDate: 'Release date',
            releaseType: 'Release type',
            status: 'Status',
            fileName: 'Apk file',
            updateInformation: 'Update information',
            innerLink: 'Inner Link',
            os: 'Operation system'
        },
        example: 'Format as 1.01.1',
        deletModel: {
            changeTitle: 'Change status',
            changeCont: 'Are you sure to change the status'
        },
        require: {
            formatError: "Only files in the APK, IPA formats are supported.",
            formatError1: "Only files in the BIN, ZIP,PAG formats are supported."
        }
    },
    appDevice:{
        addButton:'New version',
        editButton:'Edit version',
        Expire:'Expire',
        titleName:{
          id:'Id',
          pageId:'Page id',
          pageVersion:'Page version',
          appVersion:'APP version',
          status:'Status',
          fileId:'File id'
        }
      },
    account: {
        cost: {
            startMonth: 'Start month',
            endMonth: 'End month'
        }
    },
    accountHistory: {
        titleName: {
            id: 'Id',
            transTime: 'Transaction time',
            balance: 'Balance',
            transAmount: 'Transaction amount',
            postTradeBalance: 'Balance after transaction',
            type: 'Transaction type'
        }
    },
    accountSMScost: {
        titleName: {
            Month: 'Month',
            smsNumber: 'SMS count',
            totalAmount: 'Total amount'
        },
        titleName1: {
            countryNameEn: 'International name',
            countryName: 'Chinese name',
            simpleCountryName: 'Country code',
            internationalCode: 'Area code',
            locatedContinent: 'Continent',
            referencePrice: 'Reference price',
            marketPrice: 'Market price',
            Operation: 'Operation'
        },
    },
    accountRecharge: {
        addButton: 'New recharge',
        editButton: 'Edit recharge',
        titleName: {
            id: 'Id',
            transTime: 'Transaction time',
            transAmount: 'Transaction amount',
            type: 'Transaction type',
            remark: 'Remark'
        }
    },
    feedBack: {
        searchEmail: 'User email',
        selectType: 'Message status',
        User:'User',
        Admin:'Admin',
        detailModel: {
            title: 'Message',
            reply: 'Reply'
        },
        titleName: {
            id: 'Serial number',
            latestMessageTime: 'Receiver time',
            userEmail: 'User email',
            phoneNumber: 'Phone number',
            statusForManager: 'Status',
            latestMessage: 'Message',
            Operation: 'Operation'
        }
    },
    push: {
        serialNumbers: 'Serial numbers',
        receiverGroup: 'Receiver group',
        addButton: 'New push',
        titleName: {
            id: 'Serial number',
            pushTime: 'Push time',
            sendNumber: 'Send',
            readNumber: 'Read',
            pushMessage: 'Message',
            groupName: 'Receiver'
        },
        addModel: {
            title: 'Add message',
            receiverGroup: 'Group',
            message: 'Message',
            image: 'Photo'
        }
    },
    deviceLocation:{
        map:'Maps',
        baidu:'Baidu Maps',
        google:'Google Maps'
    },
    setting: {
        addTitle: 'Create customer',
        title: 'Set my profile',
        id: 'Company id',
        macMaker: 'MAC',
        registerTime: 'Create time',
        companyName: 'Company name',
        email: 'Company email',
        brandName: 'Brand name',
        companyAddress: 'Company address',
        serviceTel: 'Service telephone',
        website: 'Website',
        eStore: 'Online shops',
        remark: 'Remark',
        starLevel: 'Star level',
        smsCharge: 'SMS charges',
        activateCharge: 'Activation charge',
        homeShow: 'Home display',
        zeroBalanceSms: 'SMS service(balance<0)',
        zeroBalanceActivate: 'Allow activation(balance<0)',
        imageFid: 'The trademark',
        imageBg:'APP background image',
        imageBgTip:'Up to 6 images in png or jpg format can be uploaded, the image size is 1242*2688, and the file size does not exceed 500KB; Image file name requirements: dark image name "dark_xxx", light image "light_xxx", "xxx" part customization.',
        language: 'Language',
        password: 'API password',
        apiId:'API id',
        reset: 'Reset',
        resetTip: 'Are you sure to reset the API password?',
        emailHost:'Email host',
        emailPort:'Email port',
        emailAutoCode:'Email authorization code',
        weChatMiniAppid:'WeChat Mini AppID',
        weChatMiniSecret:'WeChat Mini AppSecret',
        googleClientId:'Google Account ID',
        weiXinAppid:'WeChat Developer Account',
        weiXinSecret:'WeChat Developer Secret',
        appleAppId:'Apple Developer Account',
        appleTeamId:'Apple Team ID',
        appleKeyId:'Apple Key ID',
        applePrivateKey:'Apple Private Key',
        applePushKeyId:'KeyId pushed by Apple',
        applePushPKey:'APNs Auth Key',
        jgAppKey:'JPush AppKey',
        jgMasteSecret:'JPush MasteSecret',
        resetPassword:'Login password',
        resetPasswordTip:'Are you sure to reset the password for this dealer?',
        resetPasswordTipOne:'Are you sure to reset the password for this installer?',
        disableTime:"Expiration date for the app's free offer",
        smsApiId:'Ihuyi SMS Verification APIID (Overseas)',
        smsApiKey:'Ihuyi SMS Verification APIKEY (Overseas)',
        smsApiIdCN:'Ihuyi SMS Verification APIID (Domestic)',
        smsApiKeyCN:'Ihuyi SMS Verification APIKEY (Domestic)',
        tip:{
            websiteFormat:"English letters+'//'+non empty strings",
            websiteExample:"For example, xxx://xxx.xxx.xxx"
         }
    },
    seceneManage:{
        titleName:{
            effectiveTime:'Effective time'
        },
        id:'Number',
        addModel:{
          title:'Create secene model rule',
          title1: 'Edit secene model rule',
          module1:'Set basic information',
          module2:'Set triggers',
          module3:'Set actions',
          sceneModelName:'Secene name',
          photo:'Secene photo',
          desc:'Description',
          addTrigger:'Add trigger',
          addAction:'Add action',
          triggerTip:'Triggers to be met: any',
          noTrigger:'No triggers set.',
          noAction:'No actions set.',
          submitTip:"The rule name cannot be empty, and please set at least one 'trigger condition' and one 'execute action'",
          WeatherCondition:'WeatherCondition',
          WindSpeed:'Wind Speed',
          WindVelocity:'Wind Velocity',
          Temperature:'Temperature',
          Humidity:'Humidity (%)',
          WindSpeedList:{
            selectAll:'All',
            select1:'<=3'
          },
          WindVelocityList:{
            selectAll:'All',
            select1:'Windless',
            select2:'East',
            select3:'South East',
            select4:'Nouth East',
            select5:'West',
            select6:'South West',
            select7:'Nouth West',
            select8:'South',
            select9:'Nouth',
            select10:'Rotating',
          },
          weatherList:{
            selectAll:'All',
            select1:'Sunny',
            select2:'Rainy',
            select3:'Snowy',
            select4:'Cloudy',
          },
          triggerTypeSelList:{
            select1:'Device Property',
            select2:'Timer',
            select3:'Device Status',
            select4: 'Manual click',
            selectWeather: 'Real-time Weather',
          },
          intSelList:{
            select1:'=',
            select2:'>',
            select3:'<',
            select4:'Value',
            select5:'Set range',
          },
          timerSelList:{
            select1:'Triggered by schedule',
            select2:'Triggered by policy',
            select3: 'Every day',
            select4: 'Weekly',
            select5: 'Monthly',
            select6: 'Yearly',
            select7: 'Special date',
          },
          timerScheduleSelList:{
            select1:'Mon',
            select2:'Tues',
            select3:'Wed',
            select4:'Thur',
            select5:'Fri',
            select6:'Sat',
            select7:'Sun',
          },
          deviceStatusList:{
            select1:'Online',
            select2:'Offline',
            select3:'Online and Offline',
          },
          selectPlaceholder:{
            baseType: 'Select basic type',
            productType: 'Select product type',
            product:'Select product',
            service:'Select service',
            property:'Select property',
            dataTime:'Select a date and time',
            repeat:'Repeat',
            interval:'Interval',
            partTime:'Select a time period',
            onceDate:'Select a specified date'
          },
          attempts:'attempts',
          seconds:'seconds',
          actionTypeSelList:{
            select1:'DeviceDeliver commands',
            select2:'Send notifications',
            select3:'Report alarms',
            select4:'Clear alarms',
            select5: 'System function',
            select6: 'Control scenes',
            select7: 'Smart device',
          },
          systemFunctionList:{
            select1:'Message reminder',
          },
          delayExecution:'Delay execution',
          editNotification:'Edit notification',
          creatTip:'The rule name must be specified and at least one trigger and one action must be configured.',
          selected:'Selected',
          noBlank:'This field cannot be left blank.',
          addtionTitle:'Add effective restrictions to the overall scene',
          addtionTitle1:'Add additional conditions',
          addtionTitle2:'Remove additional conditions',
          addtionBox:{
            addtion:'Additional condition',
            del:'Delete additional',
            title:'Effective time and times',
            all:'Whole day',
            partTime:'Part time',
            timeAndRepeat:'Time and repeat',
            start:'Start',
            end:'End'
          }
        },
        tip:{
            timeRange:'Select a time within the specified range.',
            hexColor:'Please enter a 6-digit hexadecimal color value (without #).',
          }
       },
    onboardingBanner:{
        titleName:'Add banner',
        titleNameEdit:'Edit banner ',
        link:'Web link',
        photoSTip:'Only JPG/PNG/JPEG files can be uploaded, and the size must not exceed 2MB.',
        order:'Sort Order',
        orderTip:'Higher numbers appear first'
      },
    carDealers: "CarDealers"
}